import {Injectable, EventEmitter} from '@angular/core';

@Injectable({providedIn:'root'})
export class SharedService {
  closeDialogOnSessionTimeOut = new EventEmitter();
}